import classNames from 'classnames';
import React, {ReactElement} from 'react';

import Col from '../../common/Col';
import Row from '../../common/Row';
import {useBreakpoint} from '../../common/util/useBreakpoint';
import SquareButton from './buttons/SquareButton';

type Props = {
  sideBarWidth: '150' | '400';
  backUrl: string;
  label?: string;
  title: string;
  date?: string;
  author?: string;
  extraBottomPadding?: boolean;
};

const ResourceHeader = ({
  sideBarWidth,
  backUrl,
  label,
  title,
  date,
  author,
  extraBottomPadding,
}: Props): ReactElement => {
  const {isTablet} = useBreakpoint('tablet');

  const bottomPaddingClass = extraBottomPadding ? 'pb-40' : 'pb-20';
  const sideBarClass = sideBarWidth === '150' ? 'w-[150px]' : 'w-[400px]';

  return (
    <Row className={classNames('w-full bg-primary-700 justify-center pt-24', bottomPaddingClass)}>
      {!isTablet && (
        <div className={classNames('flex-none', sideBarClass)}>
          <SquareButton
            className={'ml-auto mr-md border border-gray-100'}
            variant="light"
            direction="left"
            href={backUrl}
            aria-label="Go back"
          />
        </div>
      )}
      <Col className="w-full max-w-limit items-start bg-primary-700 px-sm">
        {!!label && (
          <div className="text-xs bg-primary-300 rounded-full py-0.5 px-8 font-medium w-min whitespace-nowrap">
            {label}
          </div>
        )}
        <div className="text-huge text-white font-semibold leading-snug mt-3">{title}</div>
        {(!!author || !!date) && (
          <Row className="space-x-3 text-white text-sm mt-8">
            {!!date && <div>{date}</div>}
            {!!author && (
              <>
                {date && <div>|</div>}
                <div className="font-semibold">{author}</div>
              </>
            )}
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default ResourceHeader;
